import { createColumnHelper } from "@tanstack/react-table";
import { format, isValid } from "date-fns";
import { PreTransaction } from "@/app/services/authorizationService/getAuthorization";
import Status from "@/view/components/Status";
import { onlyFirstName } from "@/app/utils/onlyFirstName";
import { authorizationStatusMap } from "@/app/utils/authorization";
import { BasicAvatar } from "@/view/components/BasicAvatar";
import { PartnerType } from "@/app/utils/partners.enum";
import { ProductCatalogItem } from "@/app/services/configService/getProductsCatalog";
import { PartnerImage } from "@/view/components/PartnerImage";

const columnHelper = createColumnHelper<PreTransaction>();

const formatDate = (value?: string | null) => {
  if (!value) return "-";

  const date = new Date(value);
  return isValid(date) ? format(date, "dd/MM/yyyy, HH:mm") : "-";
};

export const AuthorizationColumns = (products?: ProductCatalogItem[]) => {
  const columns = [
    columnHelper.display({
      id: "product",
      header: () => <div className="pl-4 text-left">Produto</div>,
      cell: ({ row }) => (
        <div className="flex items-center justify-start pl-4">
          <PartnerImage type={row.original?.type || PartnerType.C6} products={products} />
        </div>
      ),
    }),

    columnHelper.accessor("customerId.name", {
      id: "customer",
      header: () => <div>Cliente</div>,
      cell: ({ row }) => (
        <div>{onlyFirstName(row.original.customerId?.name || "")}</div>
      ),
    }),

    columnHelper.accessor("sellerId.name", {
      id: "seller",
      header: () => <div className="hidden text-left lg:block">Vendedor</div>,
      cell: ({ row }) => (
        <div className="hidden lg:block">
          <div className="flex items-center gap-2">
            <BasicAvatar
              name={row.original?.sellerId?.name || ""}
              profileImageUrl={row.original?.sellerId?.profileImageUrl || ""}
            />

            <div className="flex flex-col gap-1">
              <p>
                {row.original?.sellerId?.name
                  ? onlyFirstName(row.original.sellerId.name)
                  : "N/A"}
              </p>
            </div>
          </div>
        </div>
      ),
    }),

    columnHelper.accessor("createdAt", {
      id: "createdAt",
      header: () => <div className="text-center">Data criação</div>,
      cell: ({ row }) => (
        <div className="text-center">{formatDate(row.original.createdAt)}</div>
      ),
    }),

    columnHelper.accessor("linkExpirationDate", {
      id: "linkExpirationDate",
      header: () => <div className="text-center">Data expiração</div>,
      cell: ({ row }) => (
        <div className="text-center">
          {formatDate(row.original.linkExpirationDate)}
        </div>
      ),
    }),

    columnHelper.accessor("status", {
      id: "status",
      header: () => <div className="text-center">Status</div>,
      cell: ({ row }) => (
        <div className="flex justify-center">
          <Status status={authorizationStatusMap[row.original.status]} />
        </div>
      ),
    }),
  ];

  return {
    columns,
  };
};
